import { render } from "./Tasks.vue?vue&type=template&id=3b0d56bf&scoped=true&ts=true&lang=pug"
import script from "./Tasks.vue?vue&type=script&lang=ts"
export * from "./Tasks.vue?vue&type=script&lang=ts"

import "./Tasks.vue?vue&type=style&index=0&id=3b0d56bf&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0d56bf"]])

export default __exports__